import { AuthPage } from "@refinedev/antd";

export default function ForgotPassword() {
    return <AuthPage type="forgotPassword" />
}